module.exports = __webpack_public_path__ + "img/symbol_6.c506c9bf.png";